import jwt_decode from 'jwt-decode';

export const getTokenExpirationDate = (token:string) => {
  const decodedToken:any = jwt_decode(token);
  if (!decodedToken.exp) {
    return null; // Token without expiration date
  }
  const expirationDate = new Date(decodedToken.exp * 1000); // convert expiration timestamp to milliseconds
  return expirationDate;
};